import { loadScript } from '@tencent/vft-utils';

export * from './url';

export function setTitle(title:string) {
  if (title === undefined || window.document.title === title) {
    return;
  }
  document.title = title;
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  // 替换成站标favicon路径或者任意存在的较小的图片即可
  iframe.setAttribute('src', '/favicon.ico');
  const iframeCallback = () => {
    setTimeout(() => {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };
  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
}

let shield: { setStrategy: (arg0: any) => void; run: () => Promise<any> } | null = null;
// eslint-disable-next-line max-len
export async function shieldRun(secInfo: any, callback: () => any, errCallBack: (arg0: any) => any) {
  // @ts-ignore
  if (!window.VftShield) {
    await loadScript('https://vm.gtimg.cn/tencentvideo_v1/script/film/weixin/v3/lib/vftshield.min.js');
  }
  // @ts-ignore
  shield = shield || new VftShield() // eslint-disable-line
  // @ts-ignore
  shield.setStrategy(secInfo); // conifg具有类似该结构{iRet: xxx, sAppId: yyy}
  // @ts-ignore
  shield.run().then(() => {
    // 验证成功
    callback && callback() // eslint-disable-line
  }, (e: any) => {
    errCallBack && errCallBack(e) // eslint-disable-line
  });
}

export function throttle(fn: { apply: (arg0: any, arg1: any[]) => void }, delay = 50) {
  let timer: number | null = null;
  return (...args: any) => {
    if (!timer) {
      timer = setTimeout(() => {
        // @ts-ignore
        fn.apply(this, args);
        timer = null;
      }, delay);
    }
  };
}
